import script from "./SalesContactFab.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesContactFab.vue?vue&type=script&setup=true&lang=js"

import "./SalesContactFab.vue?vue&type=style&index=0&id=5d62ad4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d62ad4a"]])

export default __exports__